import _jsx from "@babel/runtime/helpers/jsx";
import React, { useRef, useMemo } from 'react';
import Context from './Context';
import defaultFeatures from './defaultFeatureConfigs';
const {
  Provider
} = Context;

/**
 * Provider to enable context for feature flag configurations.
 *
 * @param flags - Configuration flags to override default feature configurations.
 * @param children - The child components that will have access to the context.
 * @returns The provider component that wraps its children with the context.
 * @constructor
 */

function FeaturesProvider(_ref) {
  let {
    flags,
    features: definedFeatures,
    lastUpdated,
    children
  } = _ref;
  const featuresCacheRef = useRef({});
  const memoizedFeatures = useMemo(() => ({
    features: {
      ...defaultFeatures,
      ...flags?.config,
      // deprecated
      ...definedFeatures
    },
    featuresCacheRef,
    lastUpdated
  }), [definedFeatures, flags, lastUpdated, featuresCacheRef]);
  return /*#__PURE__*/_jsx(Provider, {
    value: memoizedFeatures
  }, void 0, children);
}
export default FeaturesProvider;